import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import React, { useEffect } from "react";
import Button from '../../../components/atoms/button/button';
import useMobile from '../../../hooks/useMobile';
import Query from "./query";
import { GatsbyImage } from "gatsby-plugin-image"
import { useCurrentCity } from '../../../hooks/useCurrentCity';
import './shopping-modal.scss';

const ShoppingModal = ({ setActiveShoppingModal }) => {
    const resultQuery = Query()

    const contentInfo = resultQuery.allContentfulPequeninTransversal.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]
    const mobile = useMobile();

    const title = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-shopping-modal__title">{next}</p>
        }
    };

    const footerInfo = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-shopping-modal__modal-footer-info">{next}</p>
        }
    };

    const promiseInfo = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-shopping-modal__promise-text">{next}</p>
        }
    }

    useEffect(() => {
        document.documentElement.style.overflowY = 'hidden';
        document.body.scroll = "no";
        return () => {
            document.documentElement.style.overflowY = 'scroll';
            document.body.scroll = "yes";
        }
    }, [])

    return (
        <div className="f-m-shopping-modal">
            <div className="f-m-shopping-modal__close" onClick={() => setActiveShoppingModal(false)}>
                <span className="icon-ico-x"></span>
            </div>
            <div className="f-m-shopping-modal__content">
                {contentInfo.tituloModalAliados.raw && documentToReactComponents(JSON.parse(contentInfo.tituloModalAliados.raw), title)}
                <div className="f-m-shopping-modal__allies-container">
                    {contentInfo && contentInfo.aliadosModalAliados &&
                        contentInfo.aliadosModalAliados.map((info, index) => {
                            return (

                                <a key={index} className={"f-m-shopping-modal__ally-card " + (info.isChat ? ((useCurrentCity() === "Valle de Aburrá" )? "" : "__hidden") : "")} href={info.redireccionRetailer} target="__blank" rel="noopener noreferrer" >
                                    <div className="f-m-shopping-modal__ally-image-container">

                                        {info.imagenRetailer &&

                                            info.imagenRetailer.gatsbyImageData ?
                                            <GatsbyImage
                                                className="f-m-shopping-modal__ally-image"
                                                image={info.imagenRetailer.gatsbyImageData}
                                                alt={info.imagenRetailer.description}
                                            />
                                            :
                                            <img
                                                className="f-m-shopping-modal__ally-image"
                                                src={info.imagenRetailer.file.url}
                                                alt={info.imagenRetailer.description}
                                                loading="lazy"
                                            />
                                        }
                                    </div>
                                    {
                                        info.promesaRetailer &&
                                        info.promesaRetailer.raw &&
                                        <div className="f-m-shopping-modal__promise-text-container">
                                            {documentToReactComponents(JSON.parse(info.promesaRetailer.raw), promiseInfo)}
                                        </div>
                                    }
                                    <span className="icon-ico-right-arrow f-a-shopping-modal__icon" ></span>
                                    <Button className="f-a-button__primary-blue f-a-button__small f-m-shopping-modal__ally-button"
                                        copy={info.nombreCta}
                                    />
                                </a>
                            )
                        })
                    }
                </div>
                <div className="f-m-shopping-modal__modal-footer">
                    {mobile ?
                        <>
                            <div className="f-m-shopping-modal__modal-footer-mobile-separator">
                                {contentInfo.imagenInformacionAdicionalModalAliados &&
                                    <GatsbyImage
                                        className="f-m-shopping-modal__modal-footer-image"
                                        image={contentInfo.imagenInformacionAdicionalModalAliados.gatsbyImageData}
                                        alt={contentInfo.imagenInformacionAdicionalModalAliados.description}
                                    />
                                }
                                <Button className="f-a-button__primary-blue f-a-button__extra-big f-m-shopping-modal__modal-footer-button"
                                    copy={"Comprar"}
                                    onclick={() => { window.open(contentInfo.redireccionInformacionAdicionalModalAliados, '_blank') }}
                                />
                            </div>
                            {contentInfo.informacionAdicionalModalAliados && contentInfo.informacionAdicionalModalAliados.raw && documentToReactComponents(JSON.parse(contentInfo.informacionAdicionalModalAliados.raw), footerInfo)}
                        </>
                        :
                        <>
                            {contentInfo.imagenInformacionAdicionalModalAliados &&
                                <GatsbyImage
                                    className="f-m-shopping-modal__modal-footer-image"
                                    image={contentInfo.imagenInformacionAdicionalModalAliados.gatsbyImageData}
                                    alt={contentInfo.imagenInformacionAdicionalModalAliados.description}
                                />
                            }
                            {contentInfo.informacionAdicionalModalAliados && contentInfo.informacionAdicionalModalAliados.raw && documentToReactComponents(JSON.parse(contentInfo.informacionAdicionalModalAliados.raw), footerInfo)}
                            <Button className="f-a-button__primary-blue f-a-button__extra-big f-m-shopping-modal__modal-footer-button"
                                copy={"Comprar"}
                                onclick={() => { window.open(contentInfo.redireccionInformacionAdicionalModalAliados, '_blank') }}
                            />
                        </>
                    }
                </div>
            </div>
        </div>
    )
}

export default ShoppingModal
